import { render } from "./CrearNota.vue?vue&type=template&id=cf4c8af0&scoped=true"
import script from "./CrearNota.vue?vue&type=script&lang=js"
export * from "./CrearNota.vue?vue&type=script&lang=js"

import "./CrearNota.vue?vue&type=style&index=0&id=cf4c8af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf4c8af0"]])

export default __exports__